import { Card, Center, Image, Stack, Text } from '@mantine/core';
import type { ReactNode } from 'react';

type CTACardProps = {
  button: ReactNode | null;
  /** Artwork as an asset URL. Use `imageNode` instead for an SVG that follows the theme. */
  image?: string;
  imageNode?: ReactNode;
  text: string;
  noTopMargin?: boolean;
};

export function CTACard({ button, image, imageNode, text, noTopMargin }: CTACardProps) {
  return (
    <Card mt={noTopMargin ? 0 : 'xl'} p="xl">
      <Stack align="center" gap="md">
        {imageNode ?? (image && <Image w={80} src={image} />)}
        <Text variant="body-md" ta="center" c="var(--content-primary)">
          {text}
        </Text>
        {button && <Center>{button}</Center>}
      </Stack>
    </Card>
  );
}
